/* Additional info about occurred error */
export const getBIErrorDescription = (e: any): Record<'errorDesc', string> | undefined => {
  if (e?.response?.data) {
    return { errorDesc: JSON.stringify(e.response.data.details) };
  }
};
